/*
 *
 * Settlements actions
 *
 */

import {
  DEFAULT_ACTION,
  ENABLE_LOADER,
  DISABLE_LOADER,
  UPDATE_TABLE_DATA,
  SEARCH_SETTLEMENTS,
  SEARCH_SETTLEMENTS_IMPORT,
  SAVE_SETTLEMENTS,
  SAVE_IMPORT_SETTLEMENTS,
  UPDATE_FILTERS,
  RESET_FILTERS,
  GENERATE_SETTLEMENT_REPORT,
  RESET_PAGE,
  GET_SETTLEMENT_HOLIDAYS,
  UPDATE_SETTLEMENT_HOLIDAYS,
  RESET_DATA,
  GET_UNSETTLED_AMOUNT,
  UPDATE_UNSETTLED_AMOUNT,
  GET_SETTLEMENT_RATES,
  GET_UNIFICATION_ONBOARDING,
  GET_INSTANT_SETTLEMENTS_ELIGIBILITY,
  REQUEST_INSTANT_SETTLEMENTS_ONBOARDING,
  GET_INSTANT_SETTLEMENTS_MAX_DAILY_LIMIT,
  GET_INSTANT_SETTLEMENTS_RATES_AND_LIMITS,
  GET_ON_DEMAND_SETTLEMENT_STATUS,
  GET_SETTLEMENT_TIMELINE,
  SET_SETTLEMENT_DETAILS_DATA,
  RESET_SETTLEMENT_DETAILS_DATA,
  SET_SETTLEMENT_TYPE_DATA,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function searchSettlementsAction(data) {
  return {
    type: SEARCH_SETTLEMENTS,
    data,
  };
}

export function searchImportSettlementsAction(data) {
  return {
    type: SEARCH_SETTLEMENTS_IMPORT,
    data,
  };
}

export function saveSettlementsAction(data) {
  return {
    type: SAVE_SETTLEMENTS,
    payload: data,
  };
}

export function saveImportSettlementsAction(data) {
  return {
    type: SAVE_IMPORT_SETTLEMENTS,
    payload: data,
  };
}

export function updateTableDataAction(data) {
  return {
    type: UPDATE_TABLE_DATA,
    data,
  };
}

export function updateFiltersAction(data) {
  return {
    type: UPDATE_FILTERS,
    data,
  };
}

export function resetFiltersAction(data) {
  return {
    type: RESET_FILTERS,
    data,
  };
}

export function generateSettlementReportAction(data) {
  return {
    type: GENERATE_SETTLEMENT_REPORT,
    data,
  };
}

export function resetPageAction(data) {
  return {
    type: RESET_PAGE,
    data,
  };
}

export function getSettlementsHolidaysAction(data) {
  return {
    type: GET_SETTLEMENT_HOLIDAYS,
    data,
  };
}

export function saveSettlementsHolidaysAction(data) {
  return {
    type: UPDATE_SETTLEMENT_HOLIDAYS,
    data,
  };
}

export function resetDataAction() {
  return {
    type: RESET_DATA,
  };
}

export function getUnsettledAmountAction(data) {
  return {
    type: GET_UNSETTLED_AMOUNT,
    data,
  };
}

export function updateUnsettledAmount(data) {
  return {
    type: UPDATE_UNSETTLED_AMOUNT,
    data,
  };
}

export function getSettlementRatesAction(data) {
  return {
    type: GET_SETTLEMENT_RATES,
    data,
  };
}

export function getUnificationOnBoardingAction(data) {
  return {
    type: GET_UNIFICATION_ONBOARDING,
    data,
  };
}

export function getInstantSettlementsEligibilityAction(data) {
  return {
    type: GET_INSTANT_SETTLEMENTS_ELIGIBILITY,
    data,
  };
}

export function requestInstantSettlementsOnboardingAction(data) {
  return {
    type: REQUEST_INSTANT_SETTLEMENTS_ONBOARDING,
    data,
  };
}

export function getInstantSettlementsMaxDailyLimit(data) {
  return {
    type: GET_INSTANT_SETTLEMENTS_MAX_DAILY_LIMIT,
    data,
  };
}

export function getInstantSettlementsRatesAndLimits(data) {
  return {
    type: GET_INSTANT_SETTLEMENTS_RATES_AND_LIMITS,
    data,
  };
}

export function getOnDemandSettlementStatusAction(data) {
  return {
    type: GET_ON_DEMAND_SETTLEMENT_STATUS,
    data,
  };
}

export function getSettlementTimelineAction(data) {
  return {
    type: GET_SETTLEMENT_TIMELINE,
    data,
  };
}

export const setSettlementDetailsDataAction = data => ({
  type: SET_SETTLEMENT_DETAILS_DATA,
  data,
});

export function resetSettlementDetailsDataAction() {
  return {
    type: RESET_SETTLEMENT_DETAILS_DATA,
  };
}

export function resetSettlementTypeAction(data) {
  return {
    type: SET_SETTLEMENT_TYPE_DATA,
    data,
  };
}
